import { runAction } from "./client";

export interface NotificationsResponse
{
    Notifications: ServerNotification[];    
}

export interface ServerNotification
{
    Title: string;
    Message: string;
    Action: NotificationAction;
}

export type NotificationAction = 'UndefinedAlertLevels';

export interface GetNotificationsFn
{
    (): Promise<NotificationsResponse>;
}

export const getNotifications: GetNotificationsFn = () => {
    return runAction<NotificationsResponse>('/action/GetNotifications', {});
};


// WEBPACK FOOTER //
// ./src/rest/notifications.ts